import Axios from 'axios'
import config from 'config'
import { stashLoadRequestResponseSize } from 'modules/metrics'
import Qs from 'query-string'
import { authInterceptor, encodeData } from 'utils/api'

export const JSApi = Axios.create({
  baseURL: config.EMBED_API_BASE
})

export const BootstrapFormApi = Axios.create({
  baseURL: config.BOOTSTRAP_API_BASE,
  transformRequest: ({ data }) => (encodeData(data)),
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const BootstrapJsonApi = Axios.create({
  baseURL: config.BOOTSTRAP_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const CustomerApi = Axios.create({
  baseURL: config.CUSTOMER_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  },
})

export const FlowApi = Axios.create({
  baseURL: config.FLOW_API_BASE,
  paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
  headers: {
    'Content-Type': 'application/json'
  }
})

export const MeetingsApi = Axios.create({
  baseURL: config.MEETINGS_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  },
})

export const MetricsApi = Axios.create({
  baseURL: config.METRICS_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const TargetingApi = Axios.create({
  baseURL: config.TARGETING_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const ConversationApi = Axios.create({
  baseURL: config.CONVERSATION_API_BASE
})

export const MessagesApi = Axios.create({
  baseURL: config.MESSAGES_API_BASE,
})

export const AttachmentsApi = Axios.create({
  baseURL: config.ATTACHMENTS_API_BASE,
  paramsSerializer: params => Qs.stringify(params, { arrayFormat: 'repeat' }),
  headers: {
    'Content-Type': 'application/json'
  }
})

export const GiphyApi = Axios.create({
  baseURL: config.GIPHY_API_BASE,
  params: {
    'api_key': config.GIPHY_API_KEY
  }
})

export const IframelyApi = Axios.create({
  baseURL: `${config.IFRAMELY_API_BASE}/iframely`,
  params: {
    'key': config.IFRAMELY_API_KEY
  }
})

export const IframelyEmbedApi = Axios.create({
  baseURL: `${config.IFRAMELY_API_BASE}/oembed`,
  params: {
    'key': config.IFRAMELY_API_KEY,
    'omit_script': 1
  }
})

export const EventApi = Axios.create({
  baseURL: config.EVENT_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  },
})

export const IdentifyApi = Axios.create({
  baseURL: config.EVENT_API_BASE,
  headers: {
    'Content-Type': 'application/json'
  },
})

const requestTimeInterceptor = (request) => {
  request.ts = (window.performance && window.performance.now) ? performance.now() : 0
  return request
}

const responseTimeInterceptor = (response) => {
  if (!window.performance || !window.performance.now) {
    return {
      ...response,
      responseTime: 0
    }
  }

  const responseTime =  Number(performance.now() - response.config.ts)

  return {
    ...response,
    responseTime
  }
}

const responseSizeInterceptor = (response) => {
  stashLoadRequestResponseSize(response.data)
  return response
}

EventApi.interceptors.request.use(authInterceptor)
ConversationApi.interceptors.request.use(authInterceptor)
CustomerApi.interceptors.request.use(authInterceptor)
MessagesApi.interceptors.request.use(authInterceptor)
MetricsApi.interceptors.request.use(authInterceptor)
AttachmentsApi.interceptors.request.use(authInterceptor)
TargetingApi.interceptors.request.use(authInterceptor)
MeetingsApi.interceptors.request.use(authInterceptor)
FlowApi.interceptors.request.use(authInterceptor)

BootstrapFormApi.interceptors.request.use(requestTimeInterceptor)
BootstrapJsonApi.interceptors.request.use(requestTimeInterceptor)
ConversationApi.interceptors.request.use(requestTimeInterceptor)
CustomerApi.interceptors.request.use(requestTimeInterceptor)
MessagesApi.interceptors.request.use(requestTimeInterceptor)
TargetingApi.interceptors.request.use(requestTimeInterceptor)
MeetingsApi.interceptors.request.use(requestTimeInterceptor)

BootstrapFormApi.interceptors.response.use(responseSizeInterceptor)
BootstrapJsonApi.interceptors.response.use(responseSizeInterceptor)
JSApi.interceptors.response.use(responseSizeInterceptor)
ConversationApi.interceptors.response.use(responseSizeInterceptor)
CustomerApi.interceptors.response.use(responseSizeInterceptor)
MessagesApi.interceptors.response.use(responseSizeInterceptor)
TargetingApi.interceptors.response.use(responseSizeInterceptor)
EventApi.interceptors.response.use(responseSizeInterceptor)
FlowApi.interceptors.response.use(responseSizeInterceptor)

BootstrapFormApi.interceptors.response.use(responseTimeInterceptor)
BootstrapJsonApi.interceptors.response.use(responseTimeInterceptor)
ConversationApi.interceptors.response.use(responseTimeInterceptor)
CustomerApi.interceptors.response.use(responseTimeInterceptor)
MessagesApi.interceptors.response.use(responseTimeInterceptor)
TargetingApi.interceptors.response.use(responseTimeInterceptor)
MeetingsApi.interceptors.response.use(responseTimeInterceptor)

